module.exports = __webpack_public_path__ + "img/acoes.0de6913a.png";